import { cpf as CPF } from 'cpf-cnpj-validator';
import * as yup from 'yup';

const CPF_DIGITS_LENGTH = 11;

export const onlineContractingFilterSchema = yup.object().shape({
  search: yup
    .string()
    .nullable()
    .default('')
    .optional()
    .test('cpf-or-order-id', 'Informe um CPF ou OrderID válido', (value) => {
      if (!value || value.trim() === '') return true;

      const onlyDigits = value.replace(/\D/g, '');

      return onlyDigits.length === CPF_DIGITS_LENGTH ? CPF.isValid(onlyDigits) : true;
    }),
});
